import React, { useEffect, useState } from 'react';

const CreatorActivationOverlay = ({ isOpen, rankLabel = 'Blogger', messages }) => {
  const [messageIndex, setMessageIndex] = useState(0);
  const defaultMessages = [
    `Validando estatus de ${rankLabel}...`,
    'Configurando Baul y herramientas de analitica...',
    'Sincronizando con Agora Central...',
    'Finalizando configuracion premium...'
  ];
  const activeMessages = messages?.length ? messages : defaultMessages;

  useEffect(() => {
    if (!isOpen) return;
    setMessageIndex(0);
    const interval = setInterval(() => {
      setMessageIndex((prev) => (prev + 1) % activeMessages.length);
    }, 1500);
    return () => clearInterval(interval);
  }, [isOpen, activeMessages.length]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/30">
      <div className="w-full max-w-xl rounded-2xl border border-gray-200 bg-white p-6 shadow-xl">
        <div className="flex flex-col items-center text-center">
          <div className="relative mb-4 h-16 w-16 rounded-full bg-blue-100 flex items-center justify-center">
            <div className="absolute inset-0 rounded-full border-2 border-blue-400 animate-spin"></div>
            <img src="/images/logo.png" alt="Agora Web" className="h-8 w-8" />
          </div>
          <p className="text-sm font-semibold text-gray-700">{activeMessages[messageIndex]}</p>
          <div className="mt-6 w-full">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="h-24 rounded-xl bg-gray-100 animate-pulse"></div>
              <div className="h-24 rounded-xl bg-gray-100 animate-pulse"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreatorActivationOverlay;
